module.exports = __webpack_public_path__ + "people-3wS7owg.svg";